module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.isTransaction),
      callback: function($$v) {
        _vm.isTransaction = $$v
      },
      expression: "isTransaction"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-4"
  }, [_c('small', {
    staticClass: "font-size-12 font-weight-700"
  }, [_vm._v(_vm._s(_vm.label))]), _c('v-progress-linear', {
    staticClass: "ma-1",
    attrs: {
      "value": _vm.value,
      "color": "white"
    }
  }), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("se cancelará automaticamente en " + _vm._s(_vm.timer) + " seg.")])], 1), (Math.sign(_vm.timer) === -1) ? _c('div', {
    staticClass: "d-flex mt-4"
  }, [_c('v-btn', {
    attrs: {
      "color": "white primary--text",
      "small": !_vm.isMovil,
      "block": "block"
    },
    on: {
      "click": _vm.reloadPage
    }
  }, [_vm._v("Recargar pagina")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5d3f8e2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_loading_transaction.vue
// module id = 531
// module chunks = 1